import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ModalImportarPedidosCuartesa from '../../components/pedidosVenta/ModalImportarPedidosCuartesa'
import {cerrarModalImportarPedidosCuartesa, descargarPlantillaExcelPedidosCuartesa, subirArchivosImportarPedidosCuartesa, submitImportarPedidosCuartesa} from '../../actions/pedidosVenta/pedidosVenta'

export function mapStateToProps (state) {
  return {
    ...state.pedidosVenta,
    auth: state.auth
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      cerrarModalImportarPedidosCuartesa,
      submitImportarPedidosCuartesa,   
      subirArchivosImportarPedidosCuartesa,      
      descargarPlantillaExcelPedidosCuartesa
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalImportarPedidosCuartesa))